/**
 * The Individual Row for the catalog items list
 */
import React from 'react';
import moment from 'moment';
import TableCell from '../../../ReusableComponents/Table/TableCell';
import TableRow from '../../../ReusableComponents/Table/TableRow';
import styles from './AuditStatusTableRow.module.css';
import AuditStatusTableBadge from './AuditStatusTableBadge';
import { auditDataShape } from '../_common_/propTypes';

export default function AuditStatusTableRow({ auditData }) {
  return (
    <TableRow>
      <TableCell padding="normal" align="left">
        {auditData.box_number}
      </TableCell>
      <TableCell padding="normal" align="left">
        {auditData.lpn}
      </TableCell>
      <TableCell padding="normal" align="left">
        <AuditStatusTableBadge status={auditData.status} />
      </TableCell>
      <TableCell padding="normal" align="left">
        {moment(auditData.timestamp).format('MM-DD-YYYY, h:mm:ss')}
      </TableCell>
      <TableCell padding="normal" align="left">
        {auditData.details && auditData.details.length > 0
          ? auditData.details.map((detail, idx) => (
              <div
                key={`${auditData.box_number}-${
                  detail.question || detail.message || idx
                }`}
              >
                <span className={styles.reasonLabel}>
                  {detail.question || detail.message || 'Images'}
                </span>
                <br />
                {detail.images && detail.images.length > 0
                  ? detail.images.map((image) => (
                      <span
                        className={styles.imageLink}
                        key={`${auditData.box_number}-${image}`}
                      >
                        <a
                          href={image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {image}
                        </a>
                      </span>
                    ))
                  : null}
                <br />
              </div>
            ))
          : null}
      </TableCell>
    </TableRow>
  );
}

AuditStatusTableRow.propTypes = {
  auditData: auditDataShape.isRequired,
};
